var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F6F6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4521_92260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.68 17.1832C24.68 16.616 24.6291 16.0705 24.5345 15.5469H17V18.6414H21.3055C21.12 19.6414 20.5564 20.4887 19.7091 21.056V23.0632H22.2945C23.8073 21.6705 24.68 19.6196 24.68 17.1832Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 24.9995C19.16 24.9995 20.971 24.2832 22.2946 23.0613L19.7091 21.0541C18.9928 21.5341 18.0764 21.8177 17 21.8177C14.9164 21.8177 13.1528 20.4104 12.5237 18.5195H9.85095V20.5923C11.1673 23.2068 13.8728 24.9995 17 24.9995Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5236 18.519C12.3636 18.039 12.2727 17.5262 12.2727 16.999C12.2727 16.4717 12.3636 15.959 12.5236 15.479V13.4062H9.85091C9.30909 14.4863 9 15.7081 9 16.999C9 18.2899 9.30909 19.5117 9.85091 20.5917L12.5236 18.519Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.1818C18.1746 12.1818 19.2291 12.5855 20.0582 13.3782L22.3528 11.0836C20.9673 9.79273 19.1564 9 17 9C13.8728 9 11.1673 10.7927 9.85095 13.4073L12.5237 15.48C13.1528 13.5891 14.9164 12.1818 17 12.1818Z",
    fill: "#EA4335"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4521_92260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.11a7abf8.svg";
export { ForwardRef as ReactComponent };